import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import { NotificationTypes } from '../../../../../components/Notification/notificationEnums';
import HttpStatus from '../../../../../enums/httpStatus';
import { superAiAgentsReq } from '../../../../../services/requests';
import { DeleteAiAgentModalProps } from '../../types';

const DeleteAiAgentModal = ({
  showModal,
  closeModal,
  callback,
  selectedAiAgent,
}: DeleteAiAgentModalProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const response = await superAiAgentsReq.delete(selectedAiAgent.id);

      if (response.status !== HttpStatus.OK) {
        throw response;
      }

      frontendNotification({
        message: t('successfullyDeletedAiAgent'),
        type: NotificationTypes.SUCCESS,
      });

      callback();
      closeModal();
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);
    }

    setIsLoading(false);
  };

  return (
    <Modal
      title={t('deleteAiAgent')}
      showModal={showModal}
      closeModal={closeModal}
      cancelButton={closeModal}
      action={handleDelete}
      actionNameBtn={t('delete')}
      isLoading={isLoading}
    >
      <div className="row">
        <div className="inputWithoutLabel">
          <p>{t('deleteAiAgentSure')}</p>
          <b>{selectedAiAgent.tenant?.name}</b>
          <p>{selectedAiAgent.data.url}</p>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAiAgentModal;